import React from 'react';
import PropTypes from 'prop-types';

import Divider from 'core/components/divider';
import { Label } from 'core/components/label';
import { nthDayFormatter } from 'core/helpers/formatters';
// The modal's helper, not its index: the index loads the whole modal into every card.
import { BillingDayMode, getBillingDay } from 'quote-revisit/components/payment-schedule-modal/billing-day';
// The slots module itself, not its index: the index loads every fill, this one included.
import { PolicyCardSlot } from '../slots/slots';
import useStyles from './billing-day.styles';

export const slot = PolicyCardSlot.BillingDay;

/**
 * The policy card's billing day row (#36361), under the payments row when the saved billing day isn't
 * the policy's default. Read from the offer as last saved, like the rest of the card.
 */
const BillingDay = ({ policy }) => {
  const classes = useStyles();
  const billingDay = getBillingDay(policy);
  if (billingDay?.mode !== BillingDayMode.Custom) {
    return null;
  }
  return (
    <>
      <Divider className={classes.divider} />
      <div className={classes.row}>
        <Label type="body2" className={classes.label}>
          Billing day
        </Label>
        <Label type="body2" className={classes.value}>
          {`${nthDayFormatter(billingDay.day)} of the month`}
        </Label>
      </div>
    </>
  );
};

BillingDay.propTypes = {
  policy: PropTypes.shape({
    effectiveDate: PropTypes.string,
    billingDayOfMonth: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  }).isRequired
};

export default BillingDay;
